import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Error\"}}\n\n<ErrorPage>There was an error while processing your request.</ErrorPage>")